import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UUID} from '@util/types';
import {ProductStatus} from '@services/model/product';
import {ConfigService} from '@services/infra/config.service';
import {StatusResource} from '@services/resource/status-resource';
import {Observable} from 'rxjs';
import {Option} from 'fp-ts/lib/Option';
import {optional} from '@util/http';
import {PreparedUpdateResource} from '@services/resource/prepared-update-resource';
import {StatusUpdateInfoResource} from '@services/resource/status-update-info-resource';

@Injectable({
  providedIn: 'root',
})
export class PrepareUpdateService {
  constructor(
    private readonly conf: ConfigService,
    private readonly http: HttpClient,
  ) {}

  setPrepareStatus(productId: UUID, cycleId: UUID, status: ProductStatus): Observable<void> {
    const url = `${this.conf.backendUrl}/v1/application/prepare-update/${productId}/${cycleId}/status`;
    const body: StatusResource = {status};
    return this.http.put<void>(url, body);
  }

  deletePreparedUpdate(productId: UUID, cycleId: UUID): Observable<void> {
    const url = `${this.conf.backendUrl}/v1/application/prepare-update/${productId}/${cycleId}/status`;
    return this.http.delete<void>(url);
  }

  getPreparedStatus(productId: UUID, cycleId: UUID): Observable<Option<StatusResource>> {
    const url = `${this.conf.backendUrl}/v1/application/prepare-update/${productId}/${cycleId}/status`;
    return this.http.get<StatusResource>(url).pipe(optional());
  }

  getPreparedUpdates(cycleId: UUID): Observable<PreparedUpdateResource[]> {
    const url = `${this.conf.backendUrl}/v1/application/prepare-update?cycleId=${cycleId}`;
    return this.http.get<PreparedUpdateResource[]>(url);
  }

  executePreparedUpdates(cycleId: UUID, updateInfo: StatusUpdateInfoResource): Observable<void> {
    const url = `${this.conf.backendUrl}/v1/application/prepare-update?cycleId=${cycleId}`;
    return this.http.post<void>(url, updateInfo);
  }
}
